module.exports = __webpack_public_path__ + "static/media/user.ee5bf551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/user.svg
// module id = 667
// module chunks = 0